import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcBuilding, IcPlus, IcEdit } from "../../Icons";
import axios from "axios";
import {
  Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";

const VACIO = { name: "", razonSocial: "", contacto: "", telefono: "", email: "", observaciones: "" };

function ListadoEmpresas() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [empresas, setEmpresas] = useState([]);
  const [modal, setModal] = useState(false);
  const [idEdit, setIdEdit] = useState("");
  const [form, setForm] = useState(VACIO);
  const [validaBoton, setValidaBoton] = useState(true);

  const toggle = () => setModal(!modal);
  const set = (campo) => (e) => setForm({ ...form, [campo]: e.target.value });

  useEffect(() => {
    axios.get(URL_EMPRESAS, auth)
      .then((response) => setEmpresas(response.data))
      .catch(() => {});
  }, []); // eslint-disable-line

  function abrirNuevo() {
    setIdEdit("");
    setForm(VACIO);
    toggle();
  }

  function abrirEdit(a) {
    setIdEdit(a._id);
    setForm({
      name: a.name || "", razonSocial: a.razonSocial || "", contacto: a.contacto || "",
      telefono: a.telefono || "", email: a.email || "", observaciones: a.observaciones || "",
    });
    toggle();
  }

  function guardar(event) {
    event.preventDefault();
    if (!form.name) {
      Swal.fire("Falta información", "El nombre es obligatorio", "warning");
      return;
    }
    setValidaBoton(false);

    const peticion = idEdit
      ? axios.patch(`${URL_EMPRESAS}/${idEdit}`, form, auth)
      : axios.post(URL_EMPRESAS, form, auth);

    peticion
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: idEdit ? "Editar Empresa" : "Crear Empresa",
          detalle: form.name,
          user: user.id,
        }, auth);
        setValidaBoton(true);
        toggle();
        Swal.fire("¡Listo!", idEdit ? "Empresa actualizada" : "Empresa creada", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      <Header />
      {user.menu_catalogos ? (
        <div className="card container col-sm-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcBuilding style={{ marginRight: 8, color: "#3b82f6" }} />
                Empresas
              </h3>
              <p className="page-subtitle">Empresas con las que se opera</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={abrirNuevo}>
                <IcPlus style={{ marginRight: 6 }} />
                Nueva Empresa
              </Button>
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Razón Social</th>
                <th>Contacto</th>
                <th>Teléfono</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {empresas
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.name}</td>
                    <td>{a.razonSocial}</td>
                    <td>{a.contacto}</td>
                    <td>{a.telefono}</td>
                    <td>
                      <Button color="info" size="sm" onClick={() => abrirEdit(a)}>
                        <IcEdit />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {idEdit ? <IcEdit style={{ marginRight: 8, color: "#3b82f6" }} />
                  : <IcPlus style={{ marginRight: 8, color: "#10b981" }} />}
          {idEdit ? "Editar Empresa" : "Nueva Empresa"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Nombre</Label>
              <Input type="text" value={form.name} required onChange={set("name")} />
            </Col>
            <Col md={6}>
              <Label>Razón Social</Label>
              <Input type="text" value={form.razonSocial} onChange={set("razonSocial")} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={4}>
              <Label>Contacto</Label>
              <Input type="text" value={form.contacto} onChange={set("contacto")} />
            </Col>
            <Col md={4}>
              <Label>Teléfono</Label>
              <Input type="text" value={form.telefono} onChange={set("telefono")} />
            </Col>
            <Col md={4}>
              <Label>Email</Label>
              <Input type="text" value={form.email} onChange={set("email")} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <Label>Observaciones</Label>
              <Input type="text" value={form.observaciones} onChange={set("observaciones")} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoEmpresas;
